import { render, staticRenderFns } from "./SearchCard.vue?vue&type=template&id=c596c13c"
import script from "./SearchCard.vue?vue&type=script&lang=js"
export * from "./SearchCard.vue?vue&type=script&lang=js"
import style0 from "./SearchCard.vue?vue&type=style&index=0&id=c596c13c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports